export default "__VITE_ASSET__3KiMMwS___"